import { render } from "./TotalShopping.vue?vue&type=template&id=7f869564"
import script from "./TotalShopping.vue?vue&type=script&lang=js"
export * from "./TotalShopping.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__